// extracted by mini-css-extract-plugin
export var alignCenter = "_8q-d";
export var bannerShown = "_8q-6";
export var buttonContent = "_8q-0";
export var cardList = "_8q-1";
export var centerContent = "_8q-2";
export var chevron = "_8q-3";
export var closePanelButton = "_8q-k";
export var conversationContextContainer = "_8q-l";
export var conversationDetailContainer = "_8q-4";
export var detailWrapper = "_8q-7";
export var dropdownButton = "_8q-e";
export var dropdownTitle = "_8q-9";
export var fullHeight = "_8q-5";
export var hidden = "_8q-a";
export var icon = "_8q-b";
export var mergeSuggestionWrapper = "_8q-m";
export var panel = "_8q-i";
export var portalButtonsWrapper = "_8q-c";
export var right = "_8q-j";
export var tableSummaryContainer = "_8q-8";
export var tableSummaryHeader = "_8q-g";
export var threeDotsButton = "_8q-f";
export var wide = "_8q-h";